/*=========================================================================================
  File Name: moduleAdminState.js
  Description: Admin Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
    serverMonitoringEmail: [],
    serverMonitoringEmailCount: "",

    serverMonitoringLimit: [],

    androidAppVersion: "",
    iosAppVersion: "",

    dvrsFirmwareSeq: "",
    dvrsFirmwareVersion: "",

    versionUpdateHistory: [],
    versionUpdateHisotyCount: "",

    notice: [],
    noticeCount: "",

    serverList:[],

    avgCpuSeries:[],
    maxCpuSeries:[],
    avgMemorySeries:[],
    maxMemorySeries:[],
    avgIoSeries:[],
    maxIoSeries:[],
    avgDiskSeries:[],
    maxDiskSeries:[],
    avgNRxSeries:[],
    maxNRxSeries:[],
    avgNTxSeries:[],
    maxNTxSeries:[],


    notiEmail: [],
    notiEmailCount: ""

}